import * as React from "react";
import styles from '../styles/modal-1-pie-1.module.scss';

function SvgComponent(props) {
  return (
    <div className={styles.svg}>
      <svg width="450px" height="449px" viewBox="0 0 450 449" {...props}>
      <g
        transform="translate(-84 -151) translate(13 10) translate(74 144)"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g stroke="#102666" strokeWidth={5}>
          <path
            d="M221.846 221.794l53.627 215.082C156.686 466.493 36.38 394.206 6.763 275.42-22.852 156.633 49.434 36.33 168.22 6.712 186.394 2.18 203.115.127 221.846.127v221.667z"
            fill="#D8D8D8"
          />
          <path
            d="M221.846 221.794V.127c122.424 0 221.667 99.243 221.667 221.667 0 103.57-67.547 190.027-168.04 215.082l-53.627-215.082z"
            fill="#0079B9"
          />
        </g>
        <path
          d="M342.09 226.372v-3.852h1.839v-3.032h-1.84v-10.339h-3.503a31.07 31.07 0 00-2.237 2.51 49.757 49.757 0 00-2.125 2.846 48.86 48.86 0 00-1.827 2.833 39.356 39.356 0 00-1.367 2.473v2.709h7.431v3.852h3.629zm-3.629-6.884h-3.902a18.943 18.943 0 011.84-3.057c.729-.994 1.416-1.914 2.062-2.759v5.816zm13.446 7.232c1.027 0 1.917-.182 2.671-.547.754-.364 1.375-.828 1.864-1.391a5.693 5.693 0 001.094-1.89c.24-.695.36-1.374.36-2.037 0-.746-.108-1.45-.323-2.113a4.448 4.448 0 00-1.044-1.74c-.48-.496-1.098-.89-1.851-1.18-.754-.29-1.67-.435-2.747-.435-.33 0-.687.033-1.068.1a4.598 4.598 0 00-1.119.348 4.945 4.945 0 011.044-1.728 5.509 5.509 0 011.578-1.155 7.867 7.867 0 012.013-.659c.738-.14 1.529-.22 2.374-.236-.033-.53-.066-1.04-.1-1.528l-.099-1.504c-1.69.017-3.21.253-4.56.708-1.35.456-2.502 1.119-3.455 1.989-.953.87-1.686 1.942-2.2 3.218-.513 1.276-.77 2.742-.77 4.399 0 2.303.539 4.109 1.616 5.418 1.077 1.309 2.65 1.963 4.722 1.963zm-.025-3.082c-.497 0-.912-.111-1.243-.335a2.379 2.379 0 01-.795-.932 4.735 4.735 0 01-.423-1.392 10.95 10.95 0 01-.124-1.69c0-.1.004-.215.012-.348.009-.132.013-.232.013-.298.232-.116.555-.207.97-.273.413-.067.803-.1 1.167-.1.994 0 1.703.228 2.125.684.423.455.634 1.106.634 1.95 0 .299-.046.61-.137.933a2.802 2.802 0 01-.422.882 2.39 2.39 0 01-.721.658c-.29.174-.642.261-1.056.261zm12.153-5.244c1.342 0 2.41-.414 3.206-1.242.795-.829 1.193-2.021 1.193-3.579 0-1.557-.398-2.75-1.193-3.579-.796-.828-1.864-1.242-3.206-1.242-1.342 0-2.411.414-3.206 1.242-.796.829-1.193 2.022-1.193 3.58 0 1.557.397 2.75 1.193 3.578.795.828 1.864 1.242 3.206 1.242zm2.982 7.978l9.717-17.223h-3.454l-9.718 17.223h3.455zm-2.982-10.363a1.37 1.37 0 01-1.156-.584c-.29-.39-.435-1.007-.435-1.852 0-.845.145-1.458.435-1.839a1.38 1.38 0 011.156-.572c.464 0 .845.19 1.143.572.298.381.447.994.447 1.84 0 .844-.149 1.461-.447 1.85-.298.39-.68.585-1.143.585zm12.277 10.76c1.342 0 2.41-.413 3.206-1.242.795-.828 1.193-2.021 1.193-3.579 0-1.557-.398-2.75-1.193-3.578-.795-.829-1.864-1.243-3.206-1.243-1.342 0-2.41.414-3.206 1.243-.795.828-1.193 2.021-1.193 3.578 0 1.558.398 2.75 1.193 3.58.795.828 1.864 1.242 3.206 1.242zm0-2.385a1.37 1.37 0 01-1.156-.584c-.29-.39-.435-1.007-.435-1.852 0-.845.145-1.458.435-1.839a1.38 1.38 0 011.156-.571c.464 0 .845.19 1.143.571.298.381.447.994.447 1.84 0 .844-.149 1.462-.447 1.85-.298.39-.68.585-1.143.585z"
          fill="#102666"
          fillRule="nonzero"
        />
        <circle
          stroke="#102666"
          strokeWidth={5}
          fill="#FFF"
          cx={222}
          cy={222}
          r={82}
        />
      </g>
    </svg>
    </div>
  );
}

export default SvgComponent;
